import React__default from 'react';
import cn from 'classnames';
import { Icon } from '../../Icon/Icon.js';

const Column = ({
  cell
}) => {
  const props = { ...cell.getHeaderProps(),
    ...(cell.getSortByToggleProps && cell.getSortByToggleProps({
      title: undefined
    })),
    className: cn('yt-table__cell flex flex-1 truncate p-2 align-middle text-grey-darkest hover:text-black', cell.className, {
      'yt-table__cell__group': !!cell.columns,
      'cursor-pointer': !cell.disableSorting,
      'justify-start text-left': cell.align === 'left',
      'justify-end text-right': cell.align === 'right',
      'justify-center text-center': cell.align === 'center' || !cell.align
    }),
    style: { ...cell.style,
      flex: cell.flex
    }
  };

  if (cell.isSorted) {
    props['aria-sort'] = cell.isSortedDesc ? 'descending' : 'ascending';
  }

  return React__default.createElement("div", Object.assign({}, props, {
    key: cell.id,
    "data-taco": "table-column"
  }), React__default.createElement("span", {
    className: "truncate"
  }, cell.render('Header')), cell.isSorted ? React__default.createElement(Icon, {
    name: cell.isSortedDesc ? 'chevron-down-solid' : 'chevron-up-solid',
    className: "-mt-0.5"
  }) : null);
};

export { Column };
//# sourceMappingURL=renderColumn.js.map
